import cn from "classnames";
import ItemChangePointForm from "components/bid/bidItemChanges/form";
import { itemChangeTitle } from "helpers/bid";
import { formatDateTimezone } from "helpers/bidpoint";
import { dateTimeToView } from "helpers/date";
import { itemChangePointStatuses, itemChangePointStatusesEnum } from "helpers/enums";
import { enumLabel } from "helpers/system";
import { divIcon } from "leaflet";
import React from "react";
import { Circle, Marker, Tooltip } from "react-leaflet";
import { geocoder } from "sources/map";

const ItemChangePoints = React.memo(({ itemChangePoints, ...props }) => {
    const hasParallelBidId = itemChangePoints.some((item) => item.parallelBidId);
    return itemChangePoints.map((el, index) => (
        <ItemChangePoint key={index} item={el} hasParallelBidId={hasParallelBidId} {...props} />
    ));
});

const ItemChangePoint = (props) => {
    const { updateItemChangePoint, canDragItemChangePoints, mergeMapData, modal, organization, hasParallelBidId } =
        props;
    const {
        mapObject,
        planEnterDateOffset,
        autoEnteredAt,
        planLeaveDateOffset,
        autoLeftAt,
        status,
        shiftCar,
        shiftDriver,
        shiftSecondaryDriver,
        shiftTrailer,
    } = props.item;
    if (!mapObject) {
        return null;
    }
    const { route, bidPoints, bidLastCarLocation, currentBid, bid } = props.data;
    const { city, village, county, address } = mapObject;
    const utcTimezone = formatDateTimezone({ planEnterDateOffset });
    const icon = divIcon({
        className: cn("map-icon--item-changes", {
            "map-icon--item-changes--success": status === itemChangePointStatusesEnum.Completed,
        }),
        iconSize: [22, 22],
    });
    const openBidItemChange = () => {
        const { autoEnteredAt, enteredAt, enteredAtByLogist } = bidPoints[0];
        props.modal({
            name: "default",
            title: "Перецепка/пересменка",
            windowMod: "wide",
            CustomBody: ItemChangePointForm,
            bodyData: {
                bidId: currentBid,
                route,
                bid,
                bidLastCarLocation,
                item: props.item,
                organization,
                hasParallelBidId,
                firstBidPointEntered: !!(autoEnteredAt || enteredAt || enteredAtByLogist),
            },
        });
    };

    const position = [...mapObject.location.coordinates].reverse();
    const updatePosition = ({ target }) => {
        target._icon.classList.remove("map-icon--item-changes-draged");
        const latlng = target.getLatLng();
        setTimeout(() => {
            mergeMapData({ isLoading: true });

            geocoder(latlng).then((geopoint) => {
                mergeMapData({ isLoading: false });
                if (geopoint) {
                    return modal({
                        name: "updatePosition",
                        windowMod: "wide",
                        title: "Изменение точки перецепки/пересменки",
                        text: `Вы хотите изменить точку на "${geopoint.address}"?`,
                        buttons: { confirm: "Да", cancel: "Нет" },
                        data: geopoint,
                        updatePoint: (mapObject) => updateItemChangePoint(mapObject, props.item),
                    });
                }
            });
        }, 0);
    };

    return (
        <>
            <Marker
                position={position}
                icon={icon}
                draggable={canDragItemChangePoints}
                eventHandlers={{
                    dragstart: ({ target }) => target._icon.classList.add("map-icon--item-changes-draged"),
                    dragend: updatePosition,
                    click: openBidItemChange,
                }}
                zIndexOffset={999}
            >
                <Tooltip
                    className="map__tooltip-route-marker leaflet-tooltip--left-align leaflet-tooltip--light"
                    direction="top"
                >
                    <div className="d-flex justify-content-between mb-2 white-space-normal align-items-start">
                        <div className="route-icon__time-tooltip--title">Перецепка/пересменка</div>
                        <div
                            className={cn("badge", {
                                "badge-success": status === itemChangePointStatusesEnum.Completed,
                                "badge-secondary": status !== itemChangePointStatusesEnum.Completed,
                            })}
                        >
                            {enumLabel(itemChangePointStatuses, status)}
                        </div>
                    </div>
                    <div className="route-icon__time-tooltip--header pb-1">
                        <span className="b-timeline-point__city--name">{city || village || county}</span>
                        <small className="text-muted">&nbsp;{utcTimezone}</small>
                    </div>
                    <div className="b-timeline-point__city--full pb-2">{address}</div>
                    <div className="pb-2">
                        {itemChangeTitle(shiftCar, shiftDriver, shiftSecondaryDriver, shiftTrailer, {
                            interactive: false,
                        })}
                    </div>
                    <div className="route-icon__time-tooltip">
                        <div />
                        <div className="font-weight-bold">Въезд</div>
                        <div className="font-weight-bold">Выезд</div>

                        <div className="font-weight-bold">План</div>
                        <div>{dateTimeToView(planEnterDateOffset)}</div>
                        <div>{dateTimeToView(planLeaveDateOffset)}</div>

                        <div className="font-weight-bold">Факт</div>
                        <div>{dateTimeToView(autoEnteredAt)}</div>
                        <div>{dateTimeToView(autoLeftAt)}</div>
                    </div>
                </Tooltip>
            </Marker>
            <Circle center={position} radius={mapObject.radius} />
        </>
    );
};

export default ItemChangePoints;
